import React from 'react';
import FilterPanel from '../../../components/ui/FilterPanel';

const ExportFilters = ({ 
  filters, 
  onFiltersChange, 
  isCollapsed, 
  onToggleCollapse 
}) => {
  const filterSchema = [
    {
      key: 'search',
      type: 'search',
      label: 'Search',
      placeholder: 'Search by filename, type, or reference...'
    },
    {
      key: 'dateRange',
      type: 'dateRange',
      label: 'Export Date Range'
    },
    {
      key: 'format',
      type: 'select',
      label: 'File Format',
      placeholder: 'All formats',
      clearable: true,
      options: [
        { value: 'CSV', label: 'CSV' },
        { value: 'XLSX', label: 'Excel (XLSX)' }
      ]
    },
    {
      key: 'type',
      type: 'select',
      label: 'Export Type',
      placeholder: 'All types',
      clearable: true,
      options: [
        { value: 'Sage 50', label: 'Sage 50 Audit Trail' },
        { value: 'Standard', label: 'Standard Export' },
        { value: 'Custom', label: 'Custom Export' }
      ]
    },
    {
      key: 'status',
      type: 'select',
      label: 'Status',
      placeholder: 'All statuses',
      clearable: true,
      options: [
        { value: 'completed', label: 'Completed' },
        { value: 'processing', label: 'Processing' },
        { value: 'error', label: 'Error' },
        { value: 'expired', label: 'Expired' }
      ]
    },
    {
      key: 'invoiceCount',
      type: 'number',
      label: 'Min Invoices',
      placeholder: '0',
      min: 0
    },
    {
      key: 'fileSize',
      type: 'select',
      label: 'File Size',
      placeholder: 'Any size',
      clearable: true,
      options: [
        { value: 'small', label: 'Small (< 1MB)' },
        { value: 'medium', label: 'Medium (1-10MB)' },
        { value: 'large', label: 'Large (> 10MB)' }
      ],
      quickActions: [
        {
          label: 'Last 7 days',
          filters: {
            dateRange: {
              from: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)?.toISOString()?.split('T')?.[0],
              to: new Date()?.toISOString()?.split('T')?.[0]
            }
          }
        },
        {
          label: 'Last 30 days',
          filters: {
            dateRange: {
              from: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)?.toISOString()?.split('T')?.[0],
              to: new Date()?.toISOString()?.split('T')?.[0]
            }
          }
        },
        {
          label: 'Sage 50 only',
          filters: {
            type: 'Sage 50',
            format: 'CSV'
          }
        }
      ]
    }
  ];

  return (
    <FilterPanel
      filters={filters}
      onFiltersChange={onFiltersChange}
      schema={filterSchema}
      isCollapsed={isCollapsed}
      onToggleCollapse={onToggleCollapse}
      showClearAll={true}
      className="mb-6"
    />
  );
};

export default ExportFilters;